// ThemeContext.js
import React, { createContext, useContext, useState } from 'react';

const CustomThemeContext = createContext();

export const useCustomTheme = () => useContext(CustomThemeContext);

export const CustomThemeProvider = ({ children }) => {
  const [selectedTheme, setSelectedTheme] = useState('Full Page');

  return (
    <CustomThemeContext.Provider value={{ selectedTheme, setSelectedTheme }}>
      {children}
    </CustomThemeContext.Provider>
  );
};
